import React from 'react';
import PropTypes from 'prop-types';
import { getStyle } from '../../components';
import { observer } from 'mobx-react';
import { IndexItem, SwiperItem, OrderStatusComp } from '..';
import { FooterNew } from '../orderComp/OrderStatusComp'
import { push, resetTime } from '../../utils';
import './ReturnOrder.less';
import autobind from 'autobind-decorator';

/**
 * 订单列表订单条目
 * @class GoodsView
 * @extends {React.Component<any, any>}
 */
@observer
class GoodsView extends React.Component<any, any> {
    static defaultProps = {
        prefixCls: 'return-order',
    };

    static contextTypes = {
        router: PropTypes.object
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            // data: this.props.data,
            current: this.props.current
        };
    }

    timer: any = null;
    timerAddress: any = null;

    componentDidMount() {
        let {data} = this.props;
        // 待支付倒计时
        if (data && data.countDown > 0) {
            this.timer = setInterval(() => {
                --data.countDown;
                if (data.countDown <= 0) {
                    if (this.props.onRefresh) {
                        this.props.onRefresh(this.props.index);
                    }
                    clearInterval(this.timer);
                    return false;
                }
                data.myData = resetTime(data.countDown);
                this.setState({
                    myData: data.myData
                });
            }, 1000);
        }
        // 待修改地址倒计时
        if (data && data.addressCountDown > 0) {
            this.timerAddress = setInterval(() => {
                --data.addressCountDown;
                if (data.addressCountDown <= 0) {
                    if (this.props.onRefresh) {
                        this.props.onRefresh(this.props.index);
                    }
                    clearInterval(this.timerAddress);
                    return false;
                }
                data.myDataAddress = resetTime(data.addressCountDown);
                this.setState({
                    myDataAddress: data.myDataAddress
                });
            }, 1000);
        }

        if(data.rechargeNumber){// 有手机号码的是虚拟商品
            data.isShowAddress = 'true'
        }
    }

    // 跳转方法
    @autobind
    private onPush(data): void {
        if(data.rechargeNumber){// 有手机号码的是虚拟商品
            data.orderStatus !== -2 && push(`/orderdetails/${data.orderUuid}?rechargeNumber=${data.rechargeNumber}`, this);
        }else{
            data.orderStatus !== -2 && push(`/orderdetails/${data.orderUuid}`, this);
        }
    }

    render() {
        const {prefixCls, data} = this.props;
        let style = getStyle(this.props);
        return (
            <div style={style} key={0} className={`${prefixCls}`}>
                <div className={prefixCls + 'header'} onClick={() => {
                    this.onPush(data);
                }}>
                    <OrderStatusComp {...this.props}/>
                </div>
                <div className={prefixCls + 'main'} onClick={() => {
                    this.onPush(data)
                }}>
                    {
                        data.orderItems && (data.orderItems.length !== 1 ?
                            <SwiperItem data={data.orderItems} key={0}/> :
                            <IndexItem data={data.orderItems[0]} key={1} isOrderList/>)
                    }
                </div>
                {/* <Footer {...this.props} /> */}
                <FooterNew {...this} />
            </div>
        );
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }
}

export default GoodsView;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/item/ReturnOrder.tsx